import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPageData } from "../../redux/pageSlice";
import { LoaderWrap } from "../../Component/GlobalLoader/LoaderWrap";
import "./ReachUs.css";
import TC3L from "../../Component/ReuseComponent/TCLines/TC3L";
import FormWebAr from "./FormWebAr";

export default function ReachUsArContent() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.page);

  useEffect(() => {
    if (!data || data.length === 0) {
      dispatch(fetchPageData({ page_id: 13, lang: "ar" }));
    }
  }, [dispatch, data]);

  const section1 = data.find((s) => s.section_id === "1");
  return (
    <>
      <LoaderWrap>
        <div className="ReachUsContainer">
          <section>
            <ReachUsS1 section={section1} />
          </section>
          <section>
            <ReachUsS2 />
          </section>
        </div>
      </LoaderWrap>
    </>
  );
}

function ReachUsS1({ section }) {
  return (
    <>
      <div className="ReachUsS1">
        <TC3L Head="تواصل معنا" Title={section?.title} Para={section?.description} ParaWidth="56vw" />
      </div>
    </>
  );
}

function ReachUsS2() {
  return (
    <>
      <div className="ReachUsS2">
        <FormWebAr />
      </div>
    </>
  );
}
